import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../index';

export interface NavigationCommand {
  id: string;
  path: string;
  replace?: boolean;
  state?: unknown;
}

interface NavigationState {
  pending: NavigationCommand | null;
}

const initialState: NavigationState = {
  pending: null
};

const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    navigationRequested: (state, action: PayloadAction<Omit<NavigationCommand, 'id'>>) => {
      state.pending = {
        id: `nav-${Date.now()}-${Math.random()}`,
        ...action.payload
      };
    },
    navigationHandled: (state, action: PayloadAction<string>) => {
      if (state.pending?.id === action.payload) {
        state.pending = null;
      }
    }
  }
});

export const { navigationRequested, navigationHandled } = navigationSlice.actions;
export const selectPendingNavigation = (state: RootState) => state.navigation.pending;

export default navigationSlice.reducer;
